module.exports = __webpack_public_path__ + "img/desktop_publications_top_img.205f7e23.jpg";